import * as ReselectModule from "reselect";
import { ITemplateFolderListState } from ".";
import { IApplicationState } from "..";

export const selectTemplateFolderList: ReselectModule.Selector<
  IApplicationState,
  ITemplateFolderListState
> = (state) => state.templateFolderList;
